import type { ConversationThread } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatThreadView } from "./chat-thread-view";

interface PostscriptThreadViewProps {
  thread: ConversationThread;
}

export const PostscriptThreadView = memo(function PostscriptThreadView({
  thread,
}: PostscriptThreadViewProps) {
  return <ChatThreadView channel="postscript" thread={thread} />;
});
